import { render, staticRenderFns } from "./TelstraUIVueTooltip.vue?vue&type=template&id=2cb99a6a"
import script from "./TelstraUIVueTooltip.vue.ts?vue&type=script&lang=ts&external"
export * from "./TelstraUIVueTooltip.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports